import Types from './types';

const Actions = {
  signIn: (
    { email, password },
    formRef,
    { history, from },
    resetPasswordFn
  ) => ({
    type: Types.SIGN_IN,
    payload: {
      email,
      password,
      formRef,
      history,
      from,
      resetPasswordFn,
    },
  }),
  signInSuccess: (user, { history, from }) => ({
    type: Types.SIGN_IN_SUCCESS,
    payload: { user, history, from },
  }),
  signInFailure: (message, formRef) => ({
    type: Types.SIGN_IN_FAILURE,
    payload: { message, formRef },
  }),
  signOut: history => ({
    type: Types.SIGN_OUT,
    payload: { history },
  }),
};

export default Actions;
